const footer = {
  'copyright': '© Neuronalys® 2021  - All rights reserved',
  'copyright-app': '{{app}}® is a registered trademark',
  'legal': 'Terms of use',
}

export default footer
